import CompareObject from "./CompareObject.js";

const SCALE_VALUE = 48;

export default class Everest extends CompareObject {
    constructor() {
        super();

        this.model = this.resources.items.Everest.scene.clone();
        super.setModel();
        this.setPosition();
    }

    setPosition() {
        this.model.position.set(122500, -332590, -410000);
        this.model.rotation.y = 1.35;
        this.model.scale.set(SCALE_VALUE, SCALE_VALUE, SCALE_VALUE);

        this.scene.add(this.model);
    }
}
